import {dividendTypeNamePipe, DividendTypeNamePipe} from "./type-name/DividendTypeNamePipe";
import {dividendTypeTranslationPipe, DividendTypeTranslationPipe} from "./type-translation/DividendTypeTranslationPipe";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.pipes`;

    return angular.module(moduleName, [])
                  .filter(DividendTypeNamePipe, dividendTypeNamePipe)
                  .filter(DividendTypeTranslationPipe, dividendTypeTranslationPipe)
        .name;
}
